export default "__VITE_ASSET__CdfaGbjd__"